import { TaxaClienteSimulacao } from './../model/proposta/taxa-cliente-simulacao';

export interface ParcelaFlexivel {
  quantidade: number;
  parcelas: number;
  valorParcela: number;
  valorTotal: number;
  taxa: number;
  fator: number;
  valorIof: number;
  dataCarenciaMinima: number;
  dataCarenciaMaxima: number;
  periodicidadePagamento: number;
  prazoMeses: number;
}

export class Parcela {
  quantidade: number;
  valor: number;
  permitida = false;
  recusada = false;
  taxaValida = true;
  exibir = false;
  taxa: number;
  fator: number;
  valorTotal: number;
  dataCarenciaMinima: number;
  dataCarenciaMaxima: number;
  periodicidadePagamento: number;
  prazoMeses?: number;
  parcelasFlexiveis: ParcelaFlexivel[] = [];

  constructor(taxaCliente?: TaxaClienteSimulacao, parcelaRecusada?: number) {
    if (taxaCliente) {
      this.quantidade = taxaCliente.getParcelas();
      this.valor = taxaCliente.getValorParcela();
      this.permitida = this.valor <= taxaCliente.getParcelaMax();
      this.recusada = this.valor >= taxaCliente.getParcelaRecusa();
      this.fator = taxaCliente.fator;

      if (this.recusada) {
        this.valor = null;
      }
    }

    if (parcelaRecusada) {
      this.quantidade = parcelaRecusada;
      this.permitida = false;
      this.recusada = true;
      this.valor = null;
    }
  }

  getQuantidade(): number {
    return this.quantidade;
  }

  getValor(): number {
    return this.valor;
  }

  isPermitida(): boolean {
    return this.permitida;
  }

  isTaxaValida(): boolean {
    return this.taxaValida;
  }

  setQuantidade(quantidade: number) {
    this.quantidade = quantidade;
  }

  setValor(valor: number) {
    this.valor = valor;
  }

  setExibir(exibir: boolean) {
    this.exibir = exibir;
  }

  isExibir(): boolean {
    return this.exibir;
  }

  getTaxa(): number {
    return this.taxa;
  }

  setTaxa(taxa: number) {
    this.taxa = taxa;
  }

  getFator(): number {
    return this.fator;
  }

  setFator(fator: number) {
    this.fator = fator;
  }

  setValorTotal(valorTotal: number) {
    this.valorTotal = valorTotal;
  }

  getValorTotal(): number {
    return this.valorTotal;
  }

  setDataCarenciaMinima(dataCarenciaMinima: number) {
    this.dataCarenciaMinima = dataCarenciaMinima;
  }

  setDataCarenciaMaxima(dataCarenciaMaxima: number) {
    this.dataCarenciaMaxima = dataCarenciaMaxima;
  }

  setPeriodicidadePagamento(periodicidadePagamento: number){
    this.periodicidadePagamento = periodicidadePagamento;
  }

  setPrazoMeses(prazoMeses: number){
    this.prazoMeses = prazoMeses;
  }

  getDataCarenciaMinima(): number {
    return this.dataCarenciaMinima;
  }

  getDataCarenciaMaxima(): number {
    return this.dataCarenciaMaxima;
  }

  getPeriodicidadePagamento(): number{
    return this.periodicidadePagamento;
  }

  getPrazoMeses(): number{
    return this.prazoMeses;
  }

  setParcelasFlexiveis(flexiveis: ParcelaFlexivel[]) {
    this.parcelasFlexiveis = flexiveis;
  }

  getParcelasFlexiveis(): ParcelaFlexivel[] {
    return this.parcelasFlexiveis;
  }
}
